import {
	ApolloClient,
	createHttpLink,
	InMemoryCache,
} from "@apollo/client/core";
import { createApolloProvider } from "@vue/apollo-option";

const apikey = process.env.VUE_APP_API_KEY;
const httpLink = createHttpLink({
	uri: `https://www.repligen.com/pimcore-graphql-webservices/HowllowFiberParts?apikey=${apikey}`,
});

const cache = new InMemoryCache();
const apolloClient = new ApolloClient({
	link: httpLink,
	cache,
});

export const provider = createApolloProvider({
	defaultClient: apolloClient,
});
